// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    // Select elements in the DOM
    const mobileNavTriggers = document.querySelectorAll('.js_mobile_nav');
    const body = document.querySelector('body');

    // Select all burger elements
    for (const mobileNavTrigger of mobileNavTriggers) {
        mobileNavTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            mobileNavToggle();
        });
    }
    // Toggle open class
    const mobileNavToggle = () => {
        if (body.classList.contains('nav_is_open')) {
            body.classList.remove('nav_is_open');
        } else {
            body.classList.add('nav_is_open');
        }
    }

});